import React, { useEffect } from "react";
import { Container, Row, Col, Form, FormGroup, Input } from "reactstrap";

import { useParams } from "react-router-dom";
import blogData from "../assets/data/blogData.js";
import Helmet from "../components/Helmet/Helmet";
import { Link } from "react-router-dom";

// import commentImg from "../assets/all-images/blog-1.jpg";

import "../styles/blog-details.css";

const BlogDetails = () => {
  const { slug } = useParams();
  const blog = blogData.find((blog) => blog.title === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blog]);

  return (
    <Helmet title={blog.title}>
      <section>
        <Container >
          <Row className="pt-5">
            <Col lg="15" md="15">
              <div className="blog__details">
                <img src={blog.imgUrl} alt="" className="w-50 pt-5" />
                <h2 className="section_title mt-4">{blog.title}</h2>

                <br />

                <p className="section_description">{blog.description}</p>
                <h6 className="">
                  <p className="section_description">{blog.quote}</p>
                </h6>
                
             

    

                {/* =============== comment form ============ */}
                <div className="leave__comment-form pb-3 mt-5">
                  <h4 className="comment_title">Leave a Comment</h4>
                  <p className="section_description">
                    You must sign-in to make or comment a post
                  </p>

                  <Form className="pb-5">
                    <FormGroup className=" d-flex gap-4">
                      <Input type="text" placeholder="Full name" />
                      <Input type="email" placeholder="Email" />
                    </FormGroup>

                    <FormGroup>
                      <textarea
                        rows="5"
                        className="w-100 py-2 px-3"
                        placeholder="Comment..."
                      ></textarea>
                    </FormGroup>

                    <button className="btn comment__btn mt-3">
                      send comment
                    </button>
                  </Form>
                </div>
              </div>
            </Col>

            
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default BlogDetails;